export default __webpack_public_path__ + "static/media/cookie_icon.5526d22b.svg";